export function getCalendarWeek(startDate, offsetWeek) {

    const offset = offsetWeek || 0;
    const date = new Date(startDate) || new Date();

    const offsetDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 7 * offset);

    return getWeek(offsetDate)
}

function getWeek(date) {
    date.setHours(0, 0, 0, 0); // Modifying arguments this way is bad practice. This would change the behavior if the calling code reuses the date variable after callingg this method e.g. printin the week and then the hour.
    // Thursday in current week decides the year.
    date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
    // January 4 is always in week 1.
    const week1 = new Date(date.getFullYear(), 0, 4);
    // Adjust to Thursday in week 1 and count number of weeks from date to week1.
    return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
}
